const TYPES = {
    SUPER_ADMIN: 1,
    SALES_EXECUTIVE: 2,
    SALES_MANAGER:3,
    SALES_HEAD : 4,
    MARKETING: 5,
    ACCOUNTS:6,
};



export const QUOTES_STATUS = {
    REQUESTED: 1,
    IN_PROGRESS: 2,
    COMPLETED: 3,
    REJECTED:4
};



export const CLAIM_STATUS = {
    REQUESTED: 1,
    APPROVED: 2,
    REJECTED: 3
};


export const FUNNEL_TYPES = {
    BOOK_FUNNEL: '2',
    PRODUCT_FUNNEL: '1',
};

// export const DESIGNATION_TYPES = [{
//     TEACHER: 'Teacher'},
//    { HOD: 'HOD'},
//    { PRINCIPLE:'Principal'},
//     {DEAN : 'Dean'},
//     {DIRECTOR: 'Director'},
//     {OWNER : 'Owner'},
// ];

export const DESIGNATION_TYPES = [
    'Center Head',
   'CEO',
   'Dean',
   'Director',
   'HOD',
   'Owner',
   'Principal',
    'Teacher'
   , 
 
   

];




export default TYPES;